<template>
  <section>
    <b-table class="mb-3" striped hover :items="clients"></b-table>
    <b-container fluid>
      <div>
        <b-form @submit="onSubmit" @reset="onReset">
          <b-form-group label="Client Name:" label-for="input-client-name">
            <b-form-input
              id="input-client-name"
              v-model="form.clientName"
              placeholder="Enter name"
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group label="Redirect URI:" label-for="input-client-redirect-uri">
            <b-form-input
              id="input-client-redirect-uri"
              v-model="form.redirectURI"
              placeholder="Enter your redirect uri"
              required
            ></b-form-input>
          </b-form-group>

          <b-button type="submit" variant="primary">Submit</b-button>
          <b-button type="reset" variant="danger">Reset</b-button>
        </b-form>
      </div>
    </b-container>
  </section>
</template>

<script>
  export default {
    data() {
      return {
        clients: [],
        form: {
          clientName: '',
          redirectURI: 'http://example.com/callback',
        },
        errors: null,
      };
    },
    created() {
      this.getClients();
    },
    methods: {
      getClients() {
        axios.get('/oauth/clients').then(response => {
          console.log(response.data);
          this.clients = response.data;
        });
      },
      createClient() {
        const data = {
          name: this.form.clientName,
          redirect: this.form.redirectURI,
        };

        axios
          .post('/oauth/clients', data)
          .then(response => {
            console.log(response.data);
            this.getClients();
          })
          .catch(error => {
            if (error.response.status === 500) {
              alert('Server is not responding, please try again later');
            } else if (error.response.status === 422) {
              this.errors = error.response.data.errors;
              alert(JSON.stringify(this.errors));
            } else if (error.response.status === 401) {
              alert('Unauthorized');
            } else if (error.response.status === 400) {
              alert(
                'Your request could not be proccessed, please try to refresh your page or contact support',
              );
            }
          });
      },
      onSubmit(event) {
        event.preventDefault();
        this.createClient();
      },
      onReset(event) {
        event.preventDefault();
        this.form.clientName = '';
        this.form.redirectURI = '';
        this.show = false;
        this.$nextTick(() => {
          this.show = true;
        });
      },
    },
  };
</script>
